import { useEffect, useState } from "react";
import { Badge, Button, Col, Row } from "react-bootstrap"
import { configPlayer, startQuocChien } from "../../services/authService";
import { OUT_OF_TIME_QC } from "../../constants/errMessage";
import { toast } from "react-toastify";
import { BATTLE_RESULT, PLAYER_CONFIG, PLAYER_CONFIG_LABEL, PLAYER_CONFIG_TIP, TIME_EVENT_QUOC_CHIEN } from "../../constants/Common";
import usePlayerConfig from "../../hooks/usePlayerConfig";
import usePlayerInfo from "../../hooks/usePlayerInfo";
import MoleculeCheckBox from "../../Molecule/MoleculeCheckBox";
import MoleculeSelectBox from "../../Molecule/MoleculeSelectBox";
import useQcAutoOnline from "../../hooks/useQcAutoOnline";
import useQcAtkCityIds from "../../hooks/useQcAtkCityIds";
import useQcDefCityIds from "../../hooks/useQcDefCityIds";
import useQcAtkingCityIds from "../../hooks/useQcAtkingCityIds";
import useQcAtkingPlayers from "../../hooks/useQcAtkingPlayers";
import useQcCityInfos from "../../hooks/useQcCityInfos";
import { redLandMap } from "../../constants/redLandMap";
const PlayerQuocChien = ({ playerId }) => {
    const { configs, updateSingleConfig } = usePlayerConfig(playerId)
    const { playerInfo } = usePlayerInfo(playerId)
    const [playQuocChien, setPlayQuocChien] = useState(false);
    const { qcAuto } = useQcAutoOnline(playerId);
    const { playerAtkCityIds } = useQcAtkCityIds(playerId);
    const { playerDefCityIds } = useQcDefCityIds(playerId)
    const { playerAtkingCityId } = useQcAtkingCityIds(playerId);
    const { atkingPlayer } = useQcAtkingPlayers(playerId);
    const { playerCityInfo } = useQcCityInfos(playerId);
    const [stateconfigs, setStateconfigs] = useState({});


    const atkResult = (status) => {
        let bgColor = 'secondary'
        if (status == BATTLE_RESULT.WIN) {
            bgColor = 'success'
        } else if (status == BATTLE_RESULT.DEFENSER) {
            bgColor = 'danger'
        } else {
            bgColor = 'secondary'
        }
        return (
            <Badge bg={bgColor}>{BATTLE_RESULT[status]}</Badge>
        )
    }

    const convertCityIdsToObject = (arrCityIds, isClearable = false) => {
        if (!arrCityIds instanceof Array) return []
        const result = Object.fromEntries(
            arrCityIds
                .filter(id => redLandMap.Object[id]) // chỉ lấy các id tồn tại trong redLandMap.Object
                .map(id => [id.toString(), redLandMap.Object[id].Name]) // tạo cặp [id, Name]
        );
        // console.log('convertCityIdsToObject', playerId, result)
        if (isClearable === true) {
            result[0] = "Không"
        }
        return result;
    }

    const displayCityName = (cityId) => {
        if (cityId == 0 || cityId == null) return (
            <span></span>
        )
        const cityName = redLandMap.Object[cityId]?.Name
        if (cityName == null) return (
            <span>''</span>
        )
        return (
            <span>{cityName}</span>
        )
    }

    const handleSubmitConfig = (e) => {
        e.preventDefault();
        // console.log('handleSubmit', stateconfigs);
        const newConfig = { ...stateconfigs };
        newConfig[PLAYER_CONFIG.ID_START_GAME_AFTER_S] = stateconfigs[PLAYER_CONFIG.ID_START_GAME_AFTER_S] * 60
        configPlayer(playerId, newConfig);
    }
    const updateConfig = (configId, newValue) => {
        let value = newValue;
        if (configId == PLAYER_CONFIG.ID_QC_ATK_CITY) {
            // console.log('updateConfig', playerId, configId, value)
        }
        setStateconfigs(prevConfigs => ({
            ...prevConfigs,
            [configId]: value
        }));
    }
    const handleSubmitStart = (e) => {
        if (_isQuocChienEventNow() == false) {
            toast.error(OUT_OF_TIME_QC);
            return;
        }
        const playName = playerInfo.Name;
        setPlayQuocChien(true);
        startQuocChien(playerId, playName).then((res) => {
            //console.log('handleCanquet', res.error)
            if (res.error === false) {
                setPlayQuocChien(true);
            } else {
                setPlayQuocChien(false);
            }
        }).catch((error) => {
            setPlayQuocChien(false)
        });;
    }

    const _isQuocChienEventNow = () => {
        const now = new Date();

        // Lấy thứ trong tuần (0: Chủ Nhật, 1: Thứ Hai, ..., 6: Thứ Bảy)
        const currentDayOfWeek = now.getDay();

        // Lặp qua danh sách sự kiện để kiểm tra
        try {
            for (const key in TIME_EVENT_QUOC_CHIEN) {
                const event = TIME_EVENT_QUOC_CHIEN[key];

                if (event.DAY_OF_WEEK === currentDayOfWeek) {
                    // Lấy thời gian hiện tại theo múi giờ +07:00
                    const nowTime = now.toLocaleTimeString('en-GB', { hour12: false, timeZone: 'Asia/Bangkok' });

                    // Lấy thời gian bắt đầu & kết thúc sự kiện
                    const startTime = event.START_TIME.split('+')[0]; // '19:30:00'
                    const endTime = event.END_TIME.split('+')[0];     // '20:00:00'

                    // So sánh thời gian hiện tại với khung giờ sự kiện
                    if (nowTime >= startTime && nowTime <= endTime) {
                        return true; // Đang trong thời gian sự kiện
                    }
                }
            }

            return false; // Không có sự kiện nào đang diễn ra
        } catch (error) {
            // console.log('_isQuocChienEventNow', this._name, error);
            return false;
        }
    }
    useEffect(() => {
        setPlayQuocChien(qcAuto)
        return () => {
            setPlayQuocChien(false)
        }
    }, [qcAuto])

    useEffect(() => {
        for (const configId in configs) {
            if (configId == PLAYER_CONFIG.ID_PRIORITY_HAI_SAN) {
                // updateConfig(configId, [...configs[configId]])
            } else if (configId == PLAYER_CONFIG.ID_QC_ATK_CITY) {
                setStateconfigs(prevConfigs => ({
                    ...prevConfigs,
                    [configId]: configs[configId]
                }));
                // console.log('useEffect', playerId, configId, configs[configId])
            }
            else if (configId == PLAYER_CONFIG.ID_START_GAME_AFTER_S) {
                updateConfig(configId, Math.ceil(configs[configId] / 60));
            }
            else updateConfig(configId, configs[configId]);
        }
    }, [configs])
    return (
        <Row>
            <Row className="pb-2 pt-2">
                <Col className="ps-2 d-flex align-items-center">
                    <Row xs={1} sm={1} md={2} lg={2} className="d-flex flex-row align-items-center w-100">
                        <div>
                            <MoleculeCheckBox
                                label={PLAYER_CONFIG_LABEL[PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR]}
                                tooltip={PLAYER_CONFIG_TIP[PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR]}
                                value={stateconfigs[PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR]}
                                onChange={(newValue) => { updateConfig(PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR, newValue); }}
                            />
                        </div>
                        <div className="pt-1 pt-md-0 pt-lg-0">
                            <div>
                                <MoleculeSelectBox
                                    label={PLAYER_CONFIG_LABEL[PLAYER_CONFIG.ID_QC_DEF_CITY]}
                                    tooltip={PLAYER_CONFIG_TIP[PLAYER_CONFIG.ID_QC_DEF_CITY]}
                                    lsKeyValue={convertCityIdsToObject(playerDefCityIds, true)}
                                    selectedKey={stateconfigs[PLAYER_CONFIG.ID_QC_DEF_CITY]}
                                    onChange={(newValue) => { updateConfig(PLAYER_CONFIG.ID_QC_DEF_CITY, newValue); }}
                                />
                            </div>
                            <div className="mt-2">
                                <MoleculeSelectBox
                                    label={PLAYER_CONFIG_LABEL[PLAYER_CONFIG.ID_QC_ATK_CITY]}
                                    tooltip={PLAYER_CONFIG_TIP[PLAYER_CONFIG.ID_QC_ATK_CITY]}
                                    lsKeyValue={convertCityIdsToObject(playerAtkCityIds)}
                                    selectedKey={stateconfigs[PLAYER_CONFIG.ID_QC_ATK_CITY]}
                                    onChange={(newValue) => { updateConfig(PLAYER_CONFIG.ID_QC_ATK_CITY, newValue); }}
                                />
                            </div>
                        </div>
                    </Row>
                </Col>

                <Col xs={2} sm={2} md={2} lg={2} className="d-flex align-items-center justify-content-center">
                    <Row xs={1} sm={1} md={2} lg={2}>
                        <div>
                            <Button className="mx-auto" variant="outline-primary" type="submit" onClick={(e) => { handleSubmitConfig(e); }}>Save</Button>
                        </div>
                        <div className="mt-2 mt-sm-2 mt-md-0 mt-lg-0">
                            <Button className="mx-auto" variant="success" type="submit" disabled={playQuocChien} onClick={(e) => { handleSubmitStart(e); }}>Start</Button>
                        </div>
                    </Row>
                </Col>
            </Row>

            {playerCityInfo != null && playerCityInfo.blood != null &&
                <Row xs={4} sm={4} md={5} lg={5} className="mt-2 d-flex flex-row justify-align-content-between">
                    <Col className="d-none d-sm-none d-md-block d-lg-block">
                        <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-start">
                            <Col xs="auto"><span>ATK Thành</span></Col>
                        </Row>
                        <Row className="align-items-center text-nowrap d-flex justify-content-start">
                            <Col xs="auto">
                                {displayCityName(playerAtkingCityId)}
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-start">
                            <Col xs="auto"><span>ATK</span></Col>
                        </Row>
                        <Row className="align-items-center d-flex justify-content-start">
                            <Col xs="auto">
                                <span>{atkingPlayer == null ? '' : atkingPlayer.name}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-center">
                            <Col xs="auto"><span>Kết Quả</span></Col>
                        </Row>
                        <Row className="align-items-center text-nowrap d-flex justify-content-center">
                            <Col xs="auto">
                                <span>{atkResult(atkingPlayer == null ? '' : atkingPlayer.result)}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-center">
                            <Col xs="auto"><span>Điểm</span></Col>
                        </Row>
                        <Row className="align-items-center text-nowrap d-flex justify-content-center">
                            <Col xs="auto">
                                <span>{playerCityInfo == null ? 0 : playerCityInfo.point}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-center">
                            <Col xs="auto"><span>Blood</span></Col>
                        </Row>
                        <Row className="align-items-center text-nowrap d-flex justify-content-center">
                            <Col xs="auto">
                                <span>{playerCityInfo == null ? 0 : playerCityInfo.blood}</span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        </Row>

    );
}

export default PlayerQuocChien
